// 2nd section

const PoweringConnectedHealthcare = () => {
  return (
      <div className="container mx-auto px-4 md:px-8 max-w-6xl">
        {/* Blue container with spacing from edges */}
        <div className="primary-bg px-8 py-12 md:px-12 md:py-16 lg:px-20 lg:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-center">
            {/* Left Side - Image */}
            <div className="order-2 lg:order-1 flex justify-center lg:justify-start">
              <div className="relative rounded-xl overflow-hidden shadow-xl w-[85%] md:w-[80%] lg:w-[90%]">
                <img
                  src='/assets/digitalHealthPlatform/2section.svg'
                  alt="Doctor with digital healthcare technology"
                  className="w-full h-auto object-cover max-h-[200px] md:max-h-[220px] lg:max-h-[240px]"
                />
                {/* Optional overlay for depth */}
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent pointer-events-none" />
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="order-1 lg:order-2">
              <h2 className="  font-bold text-white mb-3 md:mb-4 lg:mb-5">
                Powering Connected
                <br />
                <span className="secondary-text">Healthcare</span> Experiences
              </h2>
              
              <p className="text-xs md: lg: text-white opacity-90 leading-relaxed">
                The Avexa Digital Health Platform acts as the foundation for delivering end-to-end digital healthcare services. 
                It connects systems, users, and data sources to ensure continuity of care across different health programs. 
                By unifying technology, workflows, and insights, the platform simplifies care delivery while improving outcomes 
                and engagement.
              </p>
            </div>
          </div>
        </div>
      </div>
  );
};

export default PoweringConnectedHealthcare;